import { render, staticRenderFns } from "./t-input-search.vue?vue&type=template&id=2ff0d815&"
import script from "./t-input-search.vue?vue&type=script&lang=js&"
export * from "./t-input-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports